import type { ComponentProps } from "react"

export type IconCustomHubspotProps = ComponentProps<"svg">

function IconCustomHubspot(props: IconCustomHubspotProps) {
  const { viewBox = "0 0 18 18", fill = "currentColor", ...svgProps } = props

  return (
    <svg
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path d="M13.1 7.6V5.3a1.7 1.7 0 0 0 1-1.5 1.72 1.72 0 1 0-3.44 0 1.7 1.7 0 0 0 1 1.5v2.3A5.1 5.1 0 0 0 9.4 8.8L3.5 4.3a2 2 0 0 0 .1-.6A1.9 1.9 0 1 0 1.7 5.6a1.9 1.9 0 0 0 1-.3l5.8 4.5a5.2 5.2 0 0 0 .1 5l-1.8 1.8a1.5 1.5 0 0 0-.5-.1 1.6 1.6 0 1 0 1.6 1.6 1.5 1.5 0 0 0-.1-.5l1.8-1.8a5.14 5.14 0 1 0 4.5-8.2zm0 7.8a2.7 2.7 0 1 1 0-5.4 2.7 2.7 0 0 1 0 5.4z" />
    </svg>
  )
}

export default IconCustomHubspot
